import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for the default icon issue in React Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-icon.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png'
});

const GeoMap = () => {
  const position = [45.045844, -93.514045]; // Latitude, Longitude

  // Hook to force map to redraw when size changes
  const ForceRedraw = () => {
    const map = useMap();
    useEffect(() => {
      map.invalidateSize();
    }, [map]);

    return null;
  };

  return (
    <MapContainer center={position} zoom={13} style={{ height: '400px', width: '100%' }}>
      <ForceRedraw />
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
      />
      <Marker position={position}>
        <Popup>
          <a 
            href={`https://www.google.com/maps/search/?api=1&query=${position[0]},${position[1]}`} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Go to Google Maps
          </a>
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default GeoMap;
